import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { LUXURY } from "data/guestLuxuryTheme";

const ConfirmSheet = ({ open, onClose, onViewRequests, title, message }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: "20px",
        mx: 2,
        mb: 2,
        bgcolor: LUXURY.card,
        border: `1px solid ${LUXURY.cardBorder}`,
      },
    }}
  >
    <DialogContent sx={{ textAlign: "center", pt: 4 }}>
      <CheckCircleRoundedIcon sx={{ fontSize: 48, color: LUXURY.goldDeep, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: LUXURY.displayFont,
          fontWeight: 600,
          fontSize: "1.35rem",
          color: LUXURY.ink,
          lineHeight: 1.25,
          wordBreak: "break-word",
        }}
      >
        {title || "Request sent"}
      </Typography>
      <Typography sx={{ mt: 1, color: LUXURY.muted, fontSize: "0.9rem", lineHeight: 1.5, wordBreak: "break-word" }}>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3, gap: 1, justifyContent: "stretch" }}>
      <Button onClick={onClose} sx={{ flex: 1, minHeight: 44, fontWeight: 700, color: LUXURY.ink }}>
        Done
      </Button>
      {onViewRequests ? (
        <Button
          variant="contained"
          onClick={onViewRequests}
          sx={{
            flex: 1,
            minHeight: 44,
            fontWeight: 800,
            background: LUXURY.ctaGradient,
            color: LUXURY.forestDeep,
            boxShadow: LUXURY.ctaShadow,
            "&:hover": { background: LUXURY.ctaGradientHover },
          }}
        >
          My requests
        </Button>
      ) : null}
    </DialogActions>
  </Dialog>
);

export default ConfirmSheet;
